import { Component, Input } from '@angular/core';
import { TraitementDataComponent } from "../traitement-data/traitement-data.component";
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { Patient } from '../../../models/patient';

@Component({
  selector: 'app-traitement-data-ai-min-max',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-ai-min-max.component.html',
  styleUrl: './traitement-data-ai-min-max.component.scss'
})
export class TraitementDataAiMinMaxComponent {
  @Input() patient: Patient | undefined;
}
